// import MUI - React
import {
    Box,
    Paper,
    Typography,
    Button,
    Grid,
} from "@mui/material";
// Import Component
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
// Icons
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import { useSnackbar } from "../contexts/SnackBarContext";

const Tastierino = ({
    selectedTable,
    category,
    ordiniFiltrati,
    setSelectedCategory,
    setCheckboxSelectedIds,
    handleEditQty,
    // handleVoid,
    handleDelete,
    handlePrint,
    token,
    tenant,
    handleDisplay,
    mostraDisplay,
    cambiaTipoVariazione,
    setEditPrezzo,
    editPrezzo,
    editQty,
    setEditQty,
    setOpenDelete,
    incrementoPrezzo,
    decrementoPrezzo,
    setIncrementoPrezzo,
    setDecrementoPrezzo,
    handleSplitToggle,
    handleClearDiscount,
    handleApplyDirectPrice,
    priceEditSubmitting = false,
}) => {

    const { t } = useTranslation();
    const theme = useTheme();
    const { showSnackbar } = useSnackbar();
    const isCompactTablet = useMediaQuery("(max-width: 1180px) and (max-height: 900px)");

    //CATEGORIE
    //dimensioni 
    const categoryLength = category?.length + 1
    //assegno tutte le dimensioni delle colonne a tutte le dimensioni dello schermo
    const [col_xs, col_sm, col_md, col_lg, col_xl] = [5, 5, 4, 4, 5];

    //assegno tutte le const delle righe piene per tutte le dimensioni dello schermo
    const [fullRowCount_xs, fullRowCount_sm, fullRowCount_md, fullRowCount_lg, fullRowCount_xl] = [Math.floor((categoryLength) / col_xs), Math.floor((categoryLength) / col_sm), Math.floor((categoryLength) / col_md), Math.floor((categoryLength) / col_lg), Math.floor((categoryLength) / col_xl)]

    //calcolo tutti i resti per tutte le dimensioni dello schermo
    const [resto_xs, resto_sm, resto_md, resto_lg, resto_xl] = [(categoryLength) % col_xs, (categoryLength) % col_sm, (categoryLength) % col_md, (categoryLength) % col_lg, (categoryLength) % col_xl]
    //TASTIERINO
    const keypad = [
        "1", "2", "3", "X",
        "4", "5", "6", "+",
        "7", "8", "9", "-",
        ".", "0", "00", "C"
    ];

    // const utilityKeys = ["checkout_page.print", "checkout_page.split", "checkout_page.void", "checkout_page.edit_qty"]

    //funzione per gestire le utilityKeys
    async function handleUtilityKeys(elem) {
        switch (elem) {
            case "checkout_page.edit_qty":
                setDecrementoPrezzo(false)
                setIncrementoPrezzo(false)
                if (editQty) {
                    //comando per confermare
                    handleEditQty()
                }
                else {
                    setEditQty(true)
                    setEditPrezzo(false)
                }

                break;
            case "checkout_page.split":
                handleSplitToggle()
                break;
            case "checkout_page.delete":
                setOpenDelete(true)
                break;
            case "checkout_page.print":
                let log = await handlePrint(selectedTable, token, tenant, ordiniFiltrati)

                break;
            case "edit_price":
                if (editPrezzo) {
                    await handleApplyDirectPrice();
                } else {
                    setEditPrezzo(true)
                    setEditQty(false)
                }
                break;
            case "clear_discount":
                await handleClearDiscount()
                break;
            default:
                handleAlert(t("errorDefault"), "warning")
        }
    }

    function handleAlert(msg, type) {
        showSnackbar(msg, type)
    }

    return (
        <Box sx={{ margin: 1, }}>
            <Box sx={{ mb: 1 }}>
                {categoryLength < 1 ?
                    (
                        <Box minHeight={"1px"}>
                            <Typography>{t("checkout_page.NoCategory")}</Typography>
                        </Box>
                    )
                    :
                    (
                        <Grid container rowSpacing={0.8} columnSpacing={0.4} sx={{ width: "100%", height: "100%" }}>
                            <Grid item key="all" xs={(12 / col_xs)} sm={(12 / col_sm)} md={(12 / col_md)} lg={(12 / col_lg)} xl={(12 / col_xl)}>
                                <Button fullWidth variant="contained" onClick={() => { setSelectedCategory() }}
                                    sx={{ backgroundColor: theme.checkout.blue_button.backgroundColor, height: isCompactTablet ? 32 : "36.5px", }}>
                                    {t('all')}
                                </Button>
                            </Grid>
                            {category?.map((cat, index) => {
                                const isLastRow_xs = index >= ((fullRowCount_xs * col_xs) - 1)
                                const isLastRow_sm = index >= ((fullRowCount_sm * col_sm) - 1)
                                const isLastRow_md = index >= ((fullRowCount_md * col_md) - 1)
                                const isLastRow_lg = index >= ((fullRowCount_lg * col_lg) - 1)
                                const isLastRow_xl = index >= ((fullRowCount_xl * col_xl) - 1)
                                let [colSize_xs, colSize_sm, colSize_md, colSize_lg, colSize_xl] = [(12 / col_xs), (12 / col_sm), (12 / col_md), (12 / col_lg), (12 / col_xl)]

                                if (isLastRow_xs && resto_xs > 0)
                                    colSize_xs = (12 / resto_xs)
                                if (isLastRow_sm && resto_sm > 0)
                                    colSize_sm = (12 / resto_sm)
                                if (isLastRow_md && resto_md > 0)
                                    colSize_md = (12 / resto_md)
                                if (isLastRow_lg && resto_lg > 0)
                                    colSize_lg = (12 / resto_lg)
                                if (isLastRow_xl && resto_xl > 0)
                                    colSize_xl = (12 / resto_xl)

                                return (
                                    <Grid item key={index} xs={colSize_xs} sm={colSize_sm} md={colSize_md} lg={colSize_lg} xl={colSize_xl}>
                                        <Button fullWidth variant="contained" onClick={() => { setSelectedCategory(cat.id) }}
                                            sx={{
                                                backgroundColor: theme.checkout.blue_button.backgroundColor,
                                                display: "-webkit-box",
                                                WebkitBoxOrient: "vertical",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                lineHeight: 1.2,
                                                height: isCompactTablet ? 32 : "36.5px",
                                            }}>
                                            {cat.name}
                                        </Button>
                                    </Grid>
                                )
                            })}
                        </Grid>
                    )
                }
            </Box>
            {/*Display Importo*/}
            <Paper
                variant="outlined"
                sx={{
                    p: 1.5, mb: 1, mr: 0.4,
                    borderC: theme.checkout.display_checkout.border,
                    borderRadius: theme.checkout.display_checkout.borderRadius
                }}
            >
                <Box display="flex" alignItems="center" justifyContent="end">
                    <Typography variant="h4" sx={{
                        fontFamily: "Inter",
                        fontWeight: 600,
                        fontStyle: "Semi Bold",
                        fontSize: isCompactTablet ? "26px" : "30px",
                    }}>{mostraDisplay()}</Typography>
                </Box>
            </Paper>

            {/* Keypad */}
            <Box >
                <Grid container spacing={0.4} marginBottom={1} sx={{ width: "100%", height: "100%" }}>
                    {/* {utilityKeys.map((elem) => (
                        <Grid item key={elem} xs={3} sm={3} md={3} lg={3} xl={3}  >
                            <Button fullWidth variant="contained" onClick={() => { handleUtilityKeys(elem) }} disabled={!selectedTable || ordiniFiltrati.length < 1 || elem==="checkout_page.void"}
                                sx={{
                                    height: 40,
                                    backgroundColor: elem === (editQty && elem === "checkout_page.edit_qty") ?
                                            theme.checkout.closeCheckout_button.backgroundColor :
                                            theme.checkout.blue_button.backgroundColor
                                }}>
                                <Typography sx={{
                                    ...theme.checkout.typography_button,
                                    ...{ color: (editQty && elem === "checkout_page.edit_qty") ? (theme.checkout.closeCheckout_button.color) : (theme.checkout.blue_button.color) }
                                }}>{(editQty && elem === "checkout_page.edit_qty") ? (t("confirm")) : t(elem)}</Typography>
                            </Button>
                        </Grid>
                    ))} */}
                    <Grid item key={"checkout_page.delete"} xs={3} sm={3} md={3} lg={3} xl={3}  >
                        <Button fullWidth variant="contained" onClick={() => { handleUtilityKeys("checkout_page.delete") }} disabled={!selectedTable || ordiniFiltrati.length < 1}
                            sx={{
                                ...theme.checkout.orange_button,
                                ...{
                                    height: 40,
                                    minHeight: isCompactTablet ? 34 : 40,
                                    fontSize: 20,
                                    borderColor: theme.checkout.orange_button.backgroundColor,
                                },
                            }}>
                            <Typography sx={{
                                ...theme.checkout.typography_button, ...{ color: theme.checkout.blue_button.color }
                            }}>{t("checkout_page.delete")}</Typography>
                        </Button>
                    </Grid>
                    <Grid item key={"checkout_page.split"} xs={3} sm={3} md={3} lg={3} xl={3}  >
                        <Button fullWidth variant="contained" onClick={() => { handleUtilityKeys("checkout_page.split") }} disabled={!selectedTable || ordiniFiltrati.length < 1}
                            sx={{
                                height: isCompactTablet ? 34 : 40, backgroundColor: theme.checkout.blue_button.backgroundColor
                            }}>
                            <Typography sx={{
                                ...theme.checkout.typography_button, ...{ color: theme.checkout.blue_button.color }
                            }}>{t("checkout_page.split")}</Typography>
                        </Button>
                    </Grid>
                    <Grid item key={"checkout_page.print"} xs={3} sm={3} md={3} lg={3} xl={3}  >
                        <Button fullWidth variant="contained" onClick={() => { handleUtilityKeys("checkout_page.print") }} disabled={!selectedTable || ordiniFiltrati.length < 1}
                            sx={{
                                height: isCompactTablet ? 34 : 40, backgroundColor: theme.checkout.blue_button.backgroundColor
                            }}>
                            <Typography sx={{
                                ...theme.checkout.typography_button, ...{ color: theme.checkout.blue_button.color }
                            }}>{t("checkout_page.print")}</Typography>
                        </Button>
                    </Grid>
                    <Grid item key={"checkout_page.edit_qty"} xs={3} sm={3} md={3} lg={3} xl={3}  >
                        <Button fullWidth variant="contained" onClick={() => { handleUtilityKeys("checkout_page.edit_qty") }} disabled={!selectedTable || ordiniFiltrati.length < 1}
                            sx={{
                                height: 40,
                                minHeight: isCompactTablet ? 34 : 40,
                                backgroundColor: editQty ?
                                    theme.checkout.closeCheckout_button.backgroundColor :
                                    theme.checkout.blue_button.backgroundColor
                            }}>
                            <Typography sx={{
                                ...theme.checkout.typography_button,
                                ...{ color: editQty ? (theme.checkout.closeCheckout_button.color) : (theme.checkout.blue_button.color) }
                            }}>{editQty ? (t("confirm")) : t("checkout_page.edit_qty")}</Typography>
                        </Button>
                    </Grid>
                    <Grid item key={"edit_price"} xs={6} sm={6} md={6} lg={6} xl={6}>
                        <Button fullWidth variant="contained" onClick={() => { handleUtilityKeys("edit_price") }} disabled={!selectedTable || ordiniFiltrati.length < 1 || priceEditSubmitting}
                            sx={{
                                height: isCompactTablet ? 34 : 40,
                                backgroundColor: editPrezzo ? theme.checkout.closeCheckout_button.backgroundColor : theme.checkout.blue_button.backgroundColor
                            }}>
                            <Typography sx={{
                                ...theme.checkout.typography_button,
                                ...{ color: editPrezzo ? theme.checkout.closeCheckout_button.color : theme.checkout.blue_button.color }
                            }}>{t("checkout_page.edit_price")}</Typography>
                        </Button>
                    </Grid>
                    <Grid item key={"clear_discount"} xs={6} sm={6} md={6} lg={6} xl={6}>
                        <Button fullWidth variant="contained" onClick={() => { handleUtilityKeys("clear_discount") }} disabled={!selectedTable || ordiniFiltrati.length < 1}
                            sx={{ height: isCompactTablet ? 34 : 40, backgroundColor: theme.checkout.blue_button.backgroundColor }}>
                            <Typography sx={{ ...theme.checkout.typography_button, ...{ color: theme.checkout.blue_button.color } }}>{t("checkout_page.remove_discount")}</Typography>
                        </Button>
                    </Grid>
                </Grid>
                <Grid container spacing={0.4} sx={{ width: "100%", height: "100%" }}>
                    {keypad.map((k) => (
                        <Grid item key={k} xs={3} sm={3} md={3} lg={3} xl={3}>
                            {(k === "C" || k === "-" || k === "+" || k === "X") ?
                                (<Button fullWidth variant="outlined" onClick={() => handleDisplay(k)} disabled={priceEditSubmitting && (k === "+" || k === "-")}
                                    sx={{
                                        height: isCompactTablet ? 62 : 75,
                                        fontSize: ((incrementoPrezzo && k === "+") || (decrementoPrezzo && k === "-")) ? theme.checkout.typography_button.fontSize : 20,
                                        backgroundColor: ((incrementoPrezzo && k === "+") || (decrementoPrezzo && k === "-")) ? theme.checkout.closeCheckout_button.backgroundColor :
                                            (k === "C" ? theme.checkout.orange_button.backgroundColor : theme.checkout.cyan_button.backgroundColor),
                                        color: ((incrementoPrezzo && k === "+") || (decrementoPrezzo && k === "-")) ? (theme.checkout.closeCheckout_button.color) : (k === "C" ? theme.checkout.orange_button.color : theme.checkout.cyan_button.color),
                                        borderColor: k === "C" ? theme.checkout.orange_button.backgroundColor : theme.checkout.cyan_button.backgroundColor,

                                    }}>{(k === "+" || k === "-") ?
                                        (((incrementoPrezzo && k === "+") || (decrementoPrezzo && k === "-")) ? (t("confirm")
                                        ) : (cambiaTipoVariazione ? (k + "€") : (k + "%")))
                                        : ((k === "X") ? (<>
                                            <Typography sx={{ ...theme.checkout.typography_button, ...{ fontSize: 20, } }}
                                            >%</Typography>
                                            <SwapHorizIcon />
                                            <Typography sx={{ ...theme.checkout.typography_button, ...{ fontSize: 20, } }}
                                            >€</Typography>
                                        </>)
                                            : (k))}
                                </Button>)
                                :
                                (<Button fullWidth variant="contained" onClick={() => handleDisplay(k)}
                                    sx={{
                                        height: isCompactTablet ? 62 : 75,
                                        backgroundColor: theme.checkout.keypad_button.backgroundColor,
                                        fontSize: 24,
                                        color: theme.checkout.keypad_button.color
                                    }}> {k} </Button>
                                )}
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Box >
    );
}
export default Tastierino;
